import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_BASE = BACKEND_URL.replace(/^http/, "ws");

// Use sessionStorage (cleared on tab close) instead of localStorage to reduce
// XSS persistence window. The backend ALSO sets an httpOnly auth_token cookie
// for true XSS protection — this token is only used for WebSocket auth
// (browser WebSocket API cannot send cookies cross-origin).
const TOKEN_KEY = "bygglov_token";

export function getToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(t) {
  try {
    if (t) sessionStorage.setItem(TOKEN_KEY, t);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    // sessionStorage may be unavailable in private mode – cookie auth still works
  }
}

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
